import { useEffect } from "react";
import { trackMatVariant } from "../../../utils/tag-manager";

/**
 * Meldet einmal pro Startseitenaufruf `mat_exposure` mit `mat_variant: "3d"`:
 * Jeder Besuch bekommt die 3D-Figur (Entscheid Jan, 10.10.2026). Das Feld
 * bleibt, weil GTM und GA4 es lesen. Rueckfaelle meldet die Insel als
 * `mat_fallback`.
 *
 * Ein Effekt laeuft nur im Browser — das SSG-HTML bleibt unveraendert.
 */
export const useMatExposure = (pagePath: string): void => {
    useEffect(() => {
        trackMatVariant({ event: "mat_exposure", variant: "3d" });
    }, [pagePath]);
};
